var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","color":"#1D3557","dark":""},on:{"click":_vm.replyAll}},[_c('icon',{attrs:{"icon":"reply-all"}}),_c('span',{staticClass:"lowercase ml-1"},[_vm._v("Reply All")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }